import { createContext, useContext, useState, useCallback } from 'react';

const ClientModeContext = createContext(null);

export function ClientModeProvider({ children }) {
  const [isClientMode, setIsClientMode] = useState(false);

  const toggleClientMode = useCallback(() => {
    setIsClientMode(prev => !prev);
  }, []);

  return (
    <ClientModeContext.Provider value={{ isClientMode, setIsClientMode, toggleClientMode }}>
      {children}
    </ClientModeContext.Provider>
  );
}

export function useClientMode() {
  const context = useContext(ClientModeContext);
  if (!context) {
    throw new Error('useClientMode must be used within ClientModeProvider');
  }
  return context;
}

// Client mode pricing formula: fabric cost × 3 + stitching
export function calculateClientPrice(fabricCost, stitchingCost) {
  return (fabricCost * 3) + stitchingCost;
}

// Strip internal cost fields from an object
export function stripInternalCosts(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  
  const internalFields = [
    'internal_cost', 'cost_price', 'purchase_price', 'vendor_price',
    'fabric_cost', 'trims_cost', 'making_cost', 'margin', 'profit_margin',
    'cost_breakdown', 'supplier_cost', 'wholesale_price',
  ];
  
  const result = { ...obj };
  for (const field of internalFields) {
    if (field in result) {
      delete result[field];
    }
  }
  return result;
}

// Navigation items for client mode (restricted subset)
export const CLIENT_MODE_NAV_ITEMS = [
  { path: '/app', label: 'Dashboard', icon: 'Home' },
  { path: '/app/style-advisor', label: 'Style Advisor', icon: 'Sparkles' },
  { path: '/app/clients', label: 'Clients', icon: 'Users' },
  { path: '/app/fabrics', label: 'Fabrics', icon: 'Palette' },
  { path: '/app/orders', label: 'Orders', icon: 'ShoppingBag' },
  { path: '/app/appointments', label: 'Appointments', icon: 'Calendar' },
];
